import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { loginWithEmail, logoutUser, observeAuth } from "../firebase/auth.js";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({
    firebaseUser: null,
    user: null,
    loading: true,
    error: null
  });

  useEffect(() => {
    const unsubscribe = observeAuth(({ firebaseUser, profile, loading, error }) => {
      setState({ firebaseUser, user: profile, loading, error: error || null });
    });
    return unsubscribe;
  }, []);

  async function login(email, password) {
    const { firebaseUser, profile } = await loginWithEmail(email, password);
    setState({ firebaseUser, user: profile, loading: false, error: null });
    return profile;
  }

  async function logout() {
    await logoutUser();
    setState({ firebaseUser: null, user: null, loading: false, error: null });
  }

  const value = useMemo(
    () => ({
      ...state,
      login,
      logout,
      isAdmin: state.user?.role === "admin",
      isNormalUser: state.user?.role === "user"
    }),
    [state]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used inside AuthProvider");
  return context;
}
